import { render, staticRenderFns } from "./NewUrl.vue?vue&type=template&id=2b9f50a3&scoped=true&"
import script from "./NewUrl.vue?vue&type=script&lang=ts&"
export * from "./NewUrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f50a3",
  null
  
)

export default component.exports